import { Type } from '@angular/core';
import { ConfigurationId } from '@types';
import { FundInformationComponent } from '@products/overview/fund-information/fund-information.component';
import { OverviewDisplayComponent } from '@products/overview/overview-display-component.interface';
import { FundContentComponent } from '@products/overview/fund-content/fund-content.component';
import { FundManagementComponent } from './fund-management/fund-management.component';
import { TradingInformationComponent } from './trading-information/trading-information.component';
import { AnalizyRatingComponent } from './analizy-rating/analizy-rating.component';

export class OverviewComponentConfig {
  static readonly TRADING_INFORMATION = new OverviewComponentConfig(
    'Trading Information',
    TradingInformationComponent,
    ConfigurationId.GW
  );
  static readonly FUND_INFORMATION = new OverviewComponentConfig(
    'Fund Information',
    FundInformationComponent,
    ConfigurationId.GW
  );
  static readonly FUND_CONTENT = new OverviewComponentConfig(
    'Fund Content',
    FundContentComponent,
    ConfigurationId.GW
  );
  static readonly FUND_MANAGEMENT = new OverviewComponentConfig(
    'Fund Management',
    FundManagementComponent,
    ConfigurationId.GW
  );
  static readonly ANALIZY_RATING = new OverviewComponentConfig(
    'Analizy Ratings',
    AnalizyRatingComponent,
    ConfigurationId.GW
  );

  static allConfigs: OverviewComponentConfig[] = [
    OverviewComponentConfig.TRADING_INFORMATION,
    OverviewComponentConfig.FUND_INFORMATION,
    OverviewComponentConfig.FUND_CONTENT,
    OverviewComponentConfig.FUND_MANAGEMENT,
    OverviewComponentConfig.ANALIZY_RATING,
  ];

  // returns matching config or undefined
  static getConfig(
    key: string,
    configurationName: ConfigurationId
  ): OverviewComponentConfig {
    return this.allConfigs.find((config: OverviewComponentConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<OverviewDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
